import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { WindowService } from './services/window.service';
import { AuthService } from './services/auth.service';
import { User } from './models/user.model';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'web';
  tablaUrl = environment.apiUrl + '/tabla/view';
  isNavOpen = false;
  isHeaderHidden = false;
  currentUser: User | null = null;
  
  // activeDropdown property to track which dropdown is open
  activeDropdown: string | null = null;

  appVersion = '0.1.0';
  currentYear = new Date().getFullYear();
  environment = this.getEnvironmentName();
  isProduction = environment.production;
  
  // Variables for scroll tracking
  private lastScrollY = 0;
  private scrollDirection = 0;
  private scrollThreshold = 50;
  private scrollAmount = 0;

  constructor(
    private windowService: WindowService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Initialize the last scroll position
    this.lastScrollY = window.scrollY;
    
    // Subscribe to current user
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
    
    // Close dropdowns and navbar when route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.closeNavbar();
      this.closeDropdowns();
    });
  }

  private getEnvironmentName(): string {
    const apiUrl = environment.apiUrl;
    
    if (environment.production) {
      return 'production';
    } else if (apiUrl.includes('localhost:8080')) {
      return 'development';
    } else if (apiUrl.includes('localhost:8082') || apiUrl.includes('examenes.test.')) {
      return 'test';
    }
    return 'production';
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  getRoleDisplay(role: string): string {
    const roleMap: { [key: string]: string } = {
      'admin': 'Administrador',
      'mesa': 'Mesa de examen',
      'recepcion': 'Recepción',
      'instructor': 'Instructor',
      'readonly': 'Solo lectura'
    };
    return roleMap[role] || role;
  }

  logout(): void {
    if (confirm('¿Está seguro que desea cerrar sesión?')) {
      this.authService.logout().subscribe(
        () => {
          console.log('Logout successful');
          // AuthService already handles navigation to /login
        },
        error => {
          console.error('Logout error:', error);
          // Still redirect even if backend logout fails
        }
      );
      this.closeNavbar();
      this.closeDropdowns();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const currentScrollY = window.scrollY;
    
    if (currentScrollY <= 10) {
      this.isHeaderHidden = false;
      return;
    }
    
    const direction = currentScrollY > this.lastScrollY ? 1 : -1;
    
    if (direction !== this.scrollDirection) {
      this.scrollDirection = direction;
      this.scrollAmount = 0;
    }
    
    this.scrollAmount += Math.abs(currentScrollY - this.lastScrollY);
    
    if (this.scrollAmount > this.scrollThreshold) {
      this.isHeaderHidden = this.scrollDirection === 1;
      this.scrollAmount = 0;
    }
    
    this.lastScrollY = currentScrollY;
  }

  toggleDropdown(name: string): void {
    this.activeDropdown = this.activeDropdown === name ? null : name;
    
    if (window.innerWidth <= 768) {
      this.isNavOpen = true;
    }
  }

  closeDropdowns(): void {
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedElement = event.target as HTMLElement;
    if (!clickedElement.closest('.dropdown-toggle') && 
        !clickedElement.closest('.dropdown-menu') &&
        !clickedElement.closest('.user-menu-toggle')) {
      this.closeDropdowns();
    }
  }

  openCalculadoraPromedios(): void {
    const baseUrl = window.location.origin;
    const calculadoraUrl = baseUrl + '/#/calculadora-promedios';
    this.windowService.open(calculadoraUrl, 'calculadoraPromedios', 
      'width=350,height=580,resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no');
  }

  toggleNavbar(): void {
    this.isNavOpen = !this.isNavOpen;
    if (!this.isNavOpen) {
      this.closeDropdowns();
    }
  }

  closeNavbar(): void {
    this.isNavOpen = false;
    this.closeDropdowns();
  }
}